module.exports = __webpack_public_path__ + "img/tag3.355fee35.png";